module.exports = __webpack_public_path__ + "img/ada.b0debec4.png";